module.exports = __webpack_public_path__ + "static/media/booking_card.db01eb10.jpg";